<template>
  <div>
    <reports-title
      ref="reportsTitle"
      :title="pageTitle"
    />
    <reports-toolbar
      ref="reportsToolbar"
      :drop-menu="modelsOfCalculationsMenu"
      :report-title="pageTitle"
      :range-value="toolbarRange"
      :toolbar-disabled="isStatic || isEmptyTable"
      :selected-group-list="toolbarSelectedGroupsList"
      :group-list="toolbarGroupsList"
      :activeReportViewMode="'table'"
      @onSelectDropdown="onChangeCalculationMode"
      @onClickExpand="toggleAllGroups(true)"
      @onClickCollapse="toggleAllGroups(false)"
      @onSelectGroup="onSelectGroup"
      @onClickExport="onExport"
    />
    <div
      v-if="isShowNotificationByManualCosts"
      :style="{borderBottom: '1px solid #E5E5E5'}"
    >
      <div :style="{width: '100%', padding: '16px'}">
        <inline-notification
          type="warning"
          :text="locale('report_budget_by_resource_notification_by_projects_with_manual_budget')"
          :message-styles="{'font-size': '12px', 'white-space': 'normal'}"
          :close-button="true"
          :custom-width="'100%'"
          @onClose="isShowNotificationByManualCosts = false"
        />
      </div>
    </div>
    <skeleton-wrapper
      v-if="isShowSkeleton"
      id="skeletonWrapper"
      :style="{ height: contentHeight }"
    >
      <template #body>
        <skeletonTable />
      </template>
    </skeleton-wrapper>
    <report-table
      v-else
      ref="table"
      :config="tableConfig"
      :rows-data="filteredTableData"
      :grouping="grouping"
      :expand-settings="expandSettings"
      :local-storage-table-id="currentFilter.type"
      :skin="'horizontal-borders'"
      :style="{ height: contentHeight }"
    />
  </div>
</template>

<script>
import app from '$$app';
import reportsTitle from '../include/title.vue';
import reportsToolbar from '../include/toolbar.vue';
import constants from '$$helpers/constants';
import multiViewsProjects from '$$multiviewModel';
import controllerBudgetByResource from '../budget/controllerReportByResource';
import controllerTimeByResource from '../time/controllerReportByResource';
import reportsConstants from '../include/constants';
import projectsModel from '../../../models/projects';
import skeletonWrapper from '../../common/VueComponents/skeletons/skeletonWrapper.vue';
import statusHelper from '../../../helpers/status';
import reportTable from '../include/table/table.vue';
import budgetTableConfigs from '../budget/configTable';
import timeTableConfigs from '../time/configTable';
import reportHelpers from '../include/helpers';
import skeletonTable from '../include/table/skeleton.vue';
import Filter from '../../filter/filter';
import inlineNotification from '../../common/VueComponents/nofitication/inline/InlineNotification.vue';
import Export from '../include/export/export';
import tableHelpers from '../include/table/helpers';

export default {
  name: 'ReportsByResourcesPage',
  components: {
    reportsTitle, reportsToolbar, skeletonWrapper, reportTable, skeletonTable, inlineNotification,
  },
  props: {
    reportType: { type: String, required: true, default: 'budget' },
  },
  data() {
    return {
      appEvents: [],
      locale: __,
      filterProjectIds: [],
      filterMultiviewProjectIds: [],
      currentProjectIds: [],
      baselines: [],
      baselineData: {},
      baselineId: null,
      tableData: [],
      grouping: ['assignee'],
      calculationMode: constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED,
      toolbarRange: '',
      isShowSkeleton: true,
      expandSettings: {
        key: 0,
        isAllExpanded: true,
      },
      isStatic: true,
      isShowNotificationByManualCosts: false,
      contentHeight: '0px',
    };
  },
  computed: {
    pageTitle() {
      if (this.$route?.name === 'timeReports') {
        return reportsConstants.TITLE.time.timeByResource;
      }
      if (this.$route?.name === 'budgetReports') {
        return reportsConstants.TITLE.budget.budgetByResource;
      }

      return '';
    },
    modelsOfCalculationsMenu() {
      return reportHelpers.getModelsOfCalculationsMenu(this.isStatic, this.calculationMode, this.baselines, this.baselineId);
    },
    currentFilter() {
      return this.$store.getters['filter/currentFilter'];
    },
    baselineTasks() {
      if (this.baselineData?.tasks) {
        const baselineTasks = this.baselineData.tasks;

        return baselineTasks;
      }

      return [];
    },
    tableConfig() {
      let config = null;

      if (this.reportType === 'budget') {
        config = budgetTableConfigs.budgetByResource;
      }

      if (this.reportType === 'time') {
        config = timeTableConfigs.timeByResource;
      }

      if (config) {
        return tableHelpers.getColumnVisibilityByCalculationMode(config, this.calculationMode);
      }

      return {
        columns: [],
        state: {},
      };
    },
    tableGroupsList() {
      return [
        { type: 'task', label: __('group_by_task') },
        { type: 'project', label: __('filter_option_gantt_id_label') },
        { type: 'assignee', label: __('filter_option_assignee_label') },
      ];
    },
    toolbarGroupsList() {
      return this.tableGroupsList.filter(item => !this.grouping.includes(item.type));
    },
    toolbarSelectedGroupsList() {
      return this.tableGroupsList.filter(item => this.grouping.includes(item.type));
    },
    filteredTableData() {
      const { text, assignee } = this.currentFilter.properties;

      let filtered = reportHelpers.returnTasksByFilterText(this.tableData, text);

      filtered = reportHelpers.returnTasksByFilterAssignee(filtered, assignee);

      return filtered;
    },
    isEmptyTable() {
      return !this.filteredTableData?.length;
    },
    sourceType() {
      if (this.filterMultiviewProjectIds.length) {
        return 'multiview';
      }

      return 'projects';
    },
    baselineEnabledByCalculationMode() {
      const baselineEnabledByCalculationMode = [
        constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE, constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE
      ].includes(this.calculationMode)

      return baselineEnabledByCalculationMode;
    }
  },
  watch: {
    'currentFilter.properties': {
      handler(newProps, oldProps) {
        if (oldProps === undefined) return;

        this.calculateReportByFilter(newProps, oldProps)
      },
      deep: true,
      // immediate: true,
    },
    isShowSkeleton(flag) {
      if (!flag && this.tableData.length) {
        this.toggleAllGroups(true);
      }
    },
    calculationMode(newVal) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          calculationModel: newVal,
        },
      });
    },
  },
  created() {
    this.init();
  },
  beforeUnmount() {
    this.appEvents.forEach(event => app.off(event));
    window.removeEventListener('resize', this.calcContentHeight);
  },
  mounted() {
    const reportNameAnalytics = this.pageTitle.replace(/^exmp_chart_/, '').replace(/_title$/, '');

    userExtAnalytics.log('report_open', {
      report_type: reportNameAnalytics,
      calculation_mode: this.calculationMode,
      source_type: this.sourceType,
      projects_selected_count: this.currentProjectIds.length,
    });

    const onAfterTimeCalculation = app.on('onAfterResourcesEstimationsCalculation', result => {
      this.initResult(result);
    });
    const onAfterCostsCalculation = app.on('onAfterResourcesCostsCalculation', result => {
      this.initResult(result);
    });

    this.appEvents.push(onAfterCostsCalculation, onAfterTimeCalculation);
    this.calcContentHeight();
    window.addEventListener('resize', this.calcContentHeight);
  },
  methods: {
    calcContentHeight() {
      const viewportHeight = document.documentElement.clientHeight || window.innerHeight || 0;

      const titleRef = this.$refs.reportsTitle;
      const toolbarRef = this.$refs.reportsToolbar;

      const titleEl = titleRef && (titleRef.$el || titleRef);
      const toolbarEl = toolbarRef && (toolbarRef.$el || toolbarRef);

      const titleHeight = titleEl?.getBoundingClientRect().height || 0;
      const toolbarHeight = toolbarEl?.getBoundingClientRect().height || 0;

      const height = Math.max(viewportHeight - titleHeight - toolbarHeight, 0);

      this.contentHeight = `${height}px`;
    },
    init() {
      if (this.reportType === 'budget') {
        controllerBudgetByResource.initCostWorker();
      }

      if (this.reportType === 'time') {
        controllerTimeByResource.initTimeWorker();
      }

      this.calculationMode = this.$route?.query?.calculationModel || constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED;
      this.calculateReportByFilter(this.currentFilter.properties)
    },

    async calculateReportByFilter(newProps, oldProps = null) {
      this.isShowNotificationByManualCosts = false;

      Filter.watchChangedFilterProps(newProps, oldProps, {
        gantt_id: this.setGanttIds,
        portfolio_id: this.setMultiviewProjectIds,
        rangeDate: this.setRange,
      });

      let ids = [this.filterProjectIds, this.filterMultiviewProjectIds].find(arr => arr.length) || [];

      if (!ids.length) {
        ids = projectsModel.getAllProjects().map(project => project.gantt_id);
      }

      const projectIdsWithAutoBudget = [];

      if (this.reportType === 'budget') {
        ids.forEach(id => {
          const projectData = projectsModel.getProjectDataById(id);

          if (!projectData?.config?.auto_budget) {
            this.isShowNotificationByManualCosts = true;
          } else {
            projectIdsWithAutoBudget.push(id)
          }
        });

        this.currentProjectIds = projectIdsWithAutoBudget;
      } else {
        this.currentProjectIds = ids;
      }

      if (this.currentProjectIds?.length) {
        await this.getBaselines();
        this.updateFilterAndCalculationMode();
        this.calculateReportByWorker();
        this.showNotificationIfProjectsWithManualCostsEnabled();
      } else {
        this.tableData = [];
        this.resetCalculationMode();
        this.updateFilterAdvancedSettings({
          baselineEnabled: false,
          isShowNotificationMessage: false,
        })
        setTimeout(() => {
          this.isStatic = true;
          this.isShowSkeleton = false;
        }, 0);
      }
    },

    initResult(result) {
      if (result) {
        this.isStatic = false;
        this.tableData = result.table;
      } else {
        this.baselines = [];
        setTimeout(() => {
          this.isStatic = true;
        }, 0);
      }

      setTimeout(() => {
        this.isShowSkeleton = false;
      }, 500)

      statusHelper.handlers.hideMainSpinner();
    },

    calculateReportByWorker() {
      if (this.reportType === 'budget') {
        controllerBudgetByResource.calculateCostsByWorker(this.currentProjectIds, this.baselineTasks, this.calculationMode);
      }

      if (this.reportType === 'time') {
        controllerTimeByResource.calculateTimeByWorker(this.currentProjectIds, this.baselineTasks, this.calculationMode);
      }
    },

    recalculateReport() {
      if (this.reportType === 'budget') {
        controllerBudgetByResource.calculationMode = this.calculationMode;
        controllerBudgetByResource.initReportData();
      }

      if (this.reportType === 'time') {
        controllerTimeByResource.calculationMode = this.calculationMode;
        controllerTimeByResource.createReportResult();
      }
    },

    setGanttIds(newVal) {
      if (newVal?.length) {
        this.filterMultiviewProjectIds = [];
        this.filterProjectIds = [...newVal];
      } else {
        this.filterProjectIds = [...newVal];
      }
    },

    setMultiviewProjectIds(newVal) {
      if (newVal?.length) {
        const multiviewData = multiViewsProjects.getProjectDataById(newVal[0]);

        this.filterProjectIds = [];
        this.filterMultiviewProjectIds = [...multiviewData.ganttIDs];
      } else {
        this.filterMultiviewProjectIds = [];
      }
    },

    setRange() {
      this.toolbarRange = reportHelpers.setToolbarRangeValue(this.currentFilter);
    },

    async getBaselines() {
      this.baselineId = null;
      this.baselines = [];
      this.baselineData = {};

      if (this.currentProjectIds.length === 1) {
        await this.$store.dispatch('baselines/fetchBaselines', this.currentProjectIds[0]);

        const baselines = this.$store.getters['baselines/getProjectBaselines'](this.currentProjectIds[0])
          .map(item => ({ ...item, created_at: new Date(item.created_at) }))
          .sort((a, b) => a.created_at - b.created_at);

        if (baselines?.length) {
          this.baselines = baselines;
          this.baselineId = baselines[baselines.length - 1].id;
          await this.getBaselineData(this.baselineId);
        }
      }
    },

    async getBaselineData(baselineId) {
      const baseline = this.baselines.find(b => b.id === +baselineId);

      if (!baseline) {
        return
      }

      const data = await this.$store.dispatch('baselines/getBaselineData', { projectId: baseline.gantt_id, eventId: baseline.event_id });

      if (data) {
        this.baselineData = data;
        this.baselineId = baselineId;
      }
    },

    async onChangeCalculationMode(selected) {
      statusHelper.handlers.showMainSpinner();
      const reportNameAnalytics = this.pageTitle.replace(/^exmp_chart_/, '').replace(/_title$/, '');

      userExtAnalytics.log('report_calculation_mode_change', {
        report_type: reportNameAnalytics,
        from: this.calculationMode,
        to: selected.type,
      });

      this.calculationMode = selected.type;

      let baselineEnabled = false;

      if (selected.baselineId) {
        await this.getBaselineData(selected.baselineId);
        this.calculateReportByWorker();
        baselineEnabled = true;
      } else {
        this.baselineId = null;
        this.recalculateReport();
      }

      this.updateFilterAdvancedSettings({
        baselineEnabled: baselineEnabled,
      })
    },

    onSelectGroup(data) {
      this.grouping = this.grouping.includes(data.type)
        ? this.grouping.filter(g => g !== data.type)
        : [...this.grouping, data.type];
    },

    toggleAllGroups(flag) {
      this.expandSettings = {
        key: ++this.expandSettings.key,
        isAllExpanded: flag,
      };
    },

    showNotificationIfProjectsWithManualCostsEnabled() {
      if (this.reportType === 'budget') {
        this.currentProjectIds.forEach(id => {
          const projectData = projectsModel.getProjectDataById(id);

          if (!projectData?.config?.auto_budget) {
            this.isShowNotificationByManualCosts = true;
          }
        });
      }
    },

    onExport() {
      Export.exportTanstackTableDataToExcel({
        title: __(`${this.pageTitle}`),
        tableInstance: this.$refs.table?.tableController?.tableInstance,
        aggregatedColumns: this.tableConfig?.aggregatedColumns || [],
        nameTaskColumnKey: 'task',
        reportType: this.reportType,
      });

      userExtAnalytics.log('report_export_done', {
        export_format: 'XLSX',
        report_type: this.reportType === 'budget' ? 'budget_variance_by_resource' : 'time_variance_by_resource',
      });
    },

    updateFilterAndCalculationMode() {
      if (!this.baselineEnabledByCalculationMode && this.currentProjectIds.length > 1) {
        this.updateFilterAdvancedSettings({
          isShowNotificationMessage: false,
        })
      }

      if (this.baselineEnabledByCalculationMode && this.currentProjectIds.length > 1) {
        this.resetCalculationMode();
        this.updateFilterAdvancedSettings()
      }

      if (this.baselineEnabledByCalculationMode && !this.baselines.length) {
        this.resetCalculationMode();
        this.updateFilterAdvancedSettings({
          baselineEnabled: false,
          isShowNotificationMessage: true,
        })
      }

      if (this.baselineEnabledByCalculationMode) {
        this.updateFilterAdvancedSettings({
          baselineEnabled: true,
          isShowNotificationMessage: false,
        })
      }
    },

    updateFilterAdvancedSettings(settings = {}) {
      const defaultFilterSettings = {
        type: this.currentFilter.type,
        settings: {
          baselineEnabled: false,
          isShowNotificationMessage: false,
        }
      }

      this.$store.commit('filter/updateAdvancedSettingsByFilterType', {
        ...defaultFilterSettings,
        settings: {
          ...defaultFilterSettings.settings,
          ...settings
        }
      });
    },

    resetCalculationMode() {
      this.calculationMode = constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED;
      controllerBudgetByResource.calculationMode = constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED;
      controllerTimeByResource.calculationMode = constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED;
    }
  },
};
</script>
